module.exports = __webpack_public_path__ + "slider-05@2x.jpg?d8f671a7956607275e334d11dd8cb596";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-05@2x.jpg
// module id = 271
// module chunks = 0